export default __webpack_public_path__ + "static/media/article-date-rectangle.a6089fef.svg";